import axiosToken from "../../api/axiosClient";
import { buildQueryString } from "../../utils/reportUtils";

class ClientReportService {
  /**
   * Récupère la liste des clients
   * @param {Object} params - Paramètres
   */
  async getClients(params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(`/reports/clients${queryString}`);
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  /**
   * Récupère les détails d'un client spécifique
   * @param {number} clientId - ID du client
   * @param {Object} params - Paramètres supplémentaires
   */
  async getClientDetails(clientId, params = {}) {
    try {
      const queryString = buildQueryString(params);
      const response = await axiosToken.get(
        `/reports/clients/${clientId}${queryString}`,
      );
      return response.data;
    } catch (error) {
      throw this._handleError(error);
    }
  }

  _handleError(error) {
    return {
      message: error.response?.data?.error || "Erreur clients",
      status: error.response?.status,
    };
  }
}

export default new ClientReportService();
